import { FuzzyField, TextField, useStudioForm } from "~/components/Form";
import { FiltersSidebar, withoutBaseTableModel } from "~/components/Table";
import { CommonFilters } from "~/domain/common";
import { listLabelsSchema } from "../schemas";
import { useLabelSearchRequest } from "./LabelTable";

export function LabelFilters() {
  const [request, setRequest] = useLabelSearchRequest();

  const { control, handleSubmit } = useStudioForm({
    schema: listLabelsSchema,
    values: withoutBaseTableModel(request),
    onSubmit: setRequest,
  });

  return (
    <FiltersSidebar handleSubmit={handleSubmit}>
      <TextField control={control} name="id" />
      <FuzzyField control={control} exactName="value" fuzzyName="valueLike" />
      <TextField control={control} name="noteLike" label="Note" />
      <CommonFilters control={control} />
    </FiltersSidebar>
  );
}
